<button class="material-icon-button" type="button" :class="{ inverted }" @click="setDirty"><MaterialIcon><slot></slot></MaterialIcon></button>